if (!customElements.get('content-truncator')) {

  class ContentTruncator extends HTMLElement {
    constructor() {
      super();
      // Clicks can arrive before the viewport/idle callback initializes the
      // component. Bind the native button action independently of that work.
      this.handleClick = (event) => {
        const button = event.target.closest('.content-truncator__button');
        if (!button || !this.contains(button)) return;
        this.init();
        if (this.contentWrapper && this.content && this.button === button) this.showMoreContent();
      };
      window.initScriptOnDemand(this, this.init.bind(this));
    }

    connectedCallback() {
      this.addEventListener('click', this.handleClick);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.handleClick);
    }

    init() {
      if (this.initialized) return;
      this.contentWrapper = this.querySelector('.content-truncator__wrapper');
      this.content = this.querySelector('.content-truncator__content');
      this.button = this.querySelector('.content-truncator__button');

      if (!this.contentWrapper || !this.content || !this.button) return;

      this.initialized = true;
      this.updateButtonVisibility();

      window.addEventListener('resizeend', () => this.updateButtonVisibility());
    }

    updateButtonVisibility() {
      const contentHeight = this.content.scrollHeight;
      const wrapperHeight = this.contentWrapper.clientHeight;

      if (!this.contentWrapper.classList.contains('expanded') && contentHeight > wrapperHeight) {
        this.contentWrapper.classList.add('is-expandable');
        this.button.hidden = false;
        this.button.style.removeProperty('display');
        this.button.setAttribute('aria-expanded', 'false');
      } else {
        if (!this.contentWrapper.classList.contains('expanded')) {
          this.contentWrapper.classList.remove('is-expandable');
        }
        this.button.hidden = true;
        this.button.style.display = 'none';
      }
    }

    showMoreContent() {
      const contentHeight = this.content.scrollHeight;
      this.contentWrapper.style.setProperty('--max-content-height', `${contentHeight}px`);
      this.contentWrapper.classList.add('expanded');
      this.button.setAttribute('aria-expanded', 'true');
      this.updateButtonVisibility();
    }
  }

  customElements.define('content-truncator', ContentTruncator);
}
